var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useCallback } from 'react';
import * as Sentry from '@sentry/react';
import { useCookies } from 'react-cookie';
import ReactGA from 'react-ga';
import fetchAppLogin from '@tving/utils/src/apis/appLogin/fetchAppLogin';
import fetchAutoLogin from '@tving/utils/src/apis/autoLogin/fetchAutoLogin';
import fetchAppLogout from '@tving/utils/src/apis/logout/fetchAppLogout';
import fetchMyValidTicketList from '@tving/utils/src/apis/myValidTicketList/fetchMyValidTicketList';
import fetchOtpResultUser from '@tving/utils/src/apis/otpResultUser/fetchOtpResultUser';
import fetchProfile from '@tving/utils/src/apis/profile/fetchProfile';
import fetchUserInfo from '@tving/utils/src/apis/userInfo/fetchUserInfo';
import { CACHE_KEY, COOKIE_MAX_AGE, DEVICE_TYPE, POPUP_TYPE_TEXTS } from '@tving/utils/src/constants/commonConstants';
import { QUERY_CLIENT } from '@tving/utils/src/constants/queryConstants';
import { TICKET_TIER, TICKET_TYPE } from '@tving/utils/src/constants/userConstants';
import useStateRef from '@tving/utils/src/hooks/common/useStateRef';
import proxyAppLogin from '@tving/utils/src/proxies/appLogin/proxyAppLogin';
import proxyAutoLogin from '@tving/utils/src/proxies/autoLogin/proxyAutoLogin';
import proxyMyValidTicketList from '@tving/utils/src/proxies/myValidTicketList/proxyMyValidTicketList';
import proxyOtpResultUser from '@tving/utils/src/proxies/otpResultUser/proxyOtpResultUser';
import proxyProfile from '@tving/utils/src/proxies/profile/proxyProfile';
import proxyUserInfo from '@tving/utils/src/proxies/userInfo/proxyUserInfo';
import seGroupAmplitude from '@tving/utils/src/utils/amplitude/seGroupAmplitude';
import setUserIdAmplitude from '@tving/utils/src/utils/amplitude/setUserIdAmplitude';
import getDeviceType from '@tving/utils/src/utils/common/getDeviceType/getDeviceType';
import DeviceManagerInstance from '@tving/utils/src/utils/device';
import isAffiliate from '@tving/utils/src/utils/proxy-util/isAffiliate';
import TvingLogModule from '@tving/utils/src/utils/tving-log-module/TvingLogModule';
import { PageNavigator, twoDepth } from '@/index';
import { useFocusedBandStore, useFocusedItemStore } from '@/stores';
import { createAccessTokenApi } from '@/util/createAccessTokenApi';
import { useAccountStore } from '@stores/account';
import { useDeviceStore } from '@stores/device';
import { useLastBandIndexStore } from '@stores/lastBandIndex';
import { usePopup } from '@stores/popup';
import { useProfileStore } from '@stores/profile';
/**
 * 진입점, QR 그리고 추후에 추가될 지점에서 로그인 로직을 공통적으로 사용할 수 있어 로직을 별도로 분리합니다.
 */
var useAccount = function () {
    var _a = __read(useCookies([
        CACHE_KEY.USER_TOKEN,
        CACHE_KEY.TVING_TOKEN,
        CACHE_KEY.AUTH_TOKEN,
        CACHE_KEY.AUTH_TOKEN_NEW,
        CACHE_KEY.LAST_PASSWORD_UPDATE_DATE,
        CACHE_KEY.PROFILE_NO,
        CACHE_KEY.ACCESS_TOKEN,
        CACHE_KEY.REFRESH_TOKEN,
        CACHE_KEY.REGION_CODE,
    ]), 3), cookies = _a[0], setCookie = _a[1], removeCookie = _a[2];
    var lastPasswordUpdateDate = localStorage.getItem(CACHE_KEY.LAST_PASSWORD_UPDATE_DATE) || '';
    var setProfile = useProfileStore(function (state) { return state.setProfile; });
    var setAccount = useAccountStore(function (state) { return state.setAccount; });
    var _b = useDeviceStore(), uuid = _b.uuid, deviceInfo = _b.deviceInfo;
    var clearLastBandIndexMap = useLastBandIndexStore(function (state) { return state.clearLastBandIndexMap; });
    var setFocusedItem = useFocusedItemStore(function (state) { return state.setFocusedItem; });
    var setFocusedBand = useFocusedBandStore(function (state) { return state.setFocusedBand; });
    var removeCache = useCallback(function () {
        removeCookie(CACHE_KEY.USER_TOKEN, { path: '/', domain: '.tving.com' });
        removeCookie(CACHE_KEY.TVING_TOKEN, { path: '/', domain: '.tving.com' });
        removeCookie(CACHE_KEY.AUTH_TOKEN, { path: '/', domain: '.tving.com' });
        removeCookie(CACHE_KEY.AUTH_TOKEN_NEW, { path: '/', domain: '.tving.com' });
        removeCookie(CACHE_KEY.LAST_PASSWORD_UPDATE_DATE, { path: '/', domain: '.tving.com' });
        removeCookie(CACHE_KEY.PROFILE_NO, { path: '/', domain: '.tving.com' });
        removeCookie(CACHE_KEY.ACCESS_TOKEN, { path: '/', domain: '.tving.com' });
        removeCookie(CACHE_KEY.REFRESH_TOKEN, { path: '/', domain: '.tving.com' });
        localStorage.removeItem(CACHE_KEY.USER_TOKEN);
        localStorage.removeItem(CACHE_KEY.TVING_TOKEN);
        localStorage.removeItem(CACHE_KEY.AUTH_TOKEN);
        localStorage.removeItem(CACHE_KEY.LAST_PASSWORD_UPDATE_DATE);
        localStorage.removeItem(CACHE_KEY.PROFILE_NO);
        localStorage.removeItem(CACHE_KEY.PLAYER_SUBTITLE_SIZE_INFO);
        localStorage.removeItem(CACHE_KEY.LEGACY_USER_INFO);
        localStorage.removeItem(CACHE_KEY.ACCESS_TOKEN);
        localStorage.removeItem(CACHE_KEY.REFRESH_TOKEN);
        QUERY_CLIENT.clear();
        clearLastBandIndexMap();
        setFocusedItem(undefined);
        setFocusedBand(undefined);
        setAccount({});
    }, [clearLastBandIndexMap, removeCookie, setAccount, setFocusedBand, setFocusedItem]);
    var doLogout = useCallback(function () {
        var refreshToken = localStorage.getItem(CACHE_KEY.REFRESH_TOKEN) || cookies[CACHE_KEY.REFRESH_TOKEN] || undefined;
        if (refreshToken) {
            fetchAppLogout({ refreshToken: refreshToken }).then(function (res) {
                TvingLogModule.debug('fetchAppLogout ::', res);
            });
        }
        // 앰플리튜드 로그아웃 처리
        setUserIdAmplitude(null);
        PageNavigator.setDefaultUrl('/');
        removeCache();
        if (getDeviceType() === DEVICE_TYPE.ANDROIDTV) {
            DeviceManagerInstance.logout();
        }
        void twoDepth();
        PageNavigator.reset('/onboarding');
    }, [cookies, removeCache]);
    var showPopup = usePopup(function (state) { return state.showPopup; });
    var updateAccount = useCallback(function (tvingUser, profileNo) { return __awaiter(void 0, void 0, Promise, function () {
        var userToken, authToken, refreshToken, accessToken, regionCode, tvingAccount, tvingTickets, _a, tvingProfile_1, _b, e_1, deviceType, androidTvDeviceManager;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    PageNavigator.setDefaultUrl('/');
                    userToken = tvingUser.userToken, authToken = tvingUser.authToken, refreshToken = tvingUser.refreshToken, accessToken = tvingUser.accessToken, regionCode = tvingUser.regionCode;
                    tvingAccount = {
                        userToken: userToken,
                        authToken: authToken,
                        refreshToken: refreshToken,
                        accessToken: accessToken,
                        userId: tvingUser.userId,
                        userNo: tvingUser.userNo,
                        lastPasswordUpdateDate: tvingUser.lastPasswordUpdateDate,
                        isRealNameConfirmed: tvingUser.isRealNameConfirmed,
                        userType: tvingUser.userType,
                        isSns: tvingUser.isSns,
                        isAffiliate: false,
                        email: tvingUser.emailAddress && tvingUser.emailVendor ? "".concat(tvingUser.emailAddress, "@").concat(tvingUser.emailVendor) : undefined,
                        profileAdultCertifiedDate: '',
                        profileToken: '',
                        profileNo: '',
                        profileName: '',
                        profileImageUrl: '',
                        isMainProfile: false,
                        hasPassword: false,
                        adultCertificationDate: '',
                        ticketTier: 0,
                        ticketType: TICKET_TYPE.TVING,
                        ticketProductId: 0,
                        ticketName: '',
                        tvingTickets: [],
                        regionCode: regionCode,
                    };
                    // check lastPasswordUpdateDate
                    if (lastPasswordUpdateDate && tvingUser.lastPasswordUpdateDate !== lastPasswordUpdateDate) {
                        showPopup(POPUP_TYPE_TEXTS.PASSWORD_CHANGED_LOGOUT, [
                            {
                                text: '확인',
                                handleSelect: doLogout,
                            },
                        ], doLogout);
                        return [2 /*return*/, null];
                    }
                    _a = proxyMyValidTicketList;
                    return [4 /*yield*/, fetchMyValidTicketList({
                            apiUserToken: userToken,
                        })];
                case 1:
                    tvingTickets = _a.apply(void 0, [_c.sent()]);
                    if (tvingTickets.length > 0) {
                        tvingAccount.ticketTier = tvingTickets[0].ticketTier || 0;
                        tvingAccount.ticketType = tvingTickets[0].ticketType;
                        tvingAccount.isAffiliate = isAffiliate(tvingAccount.ticketType);
                        tvingAccount.ticketProductId = tvingTickets[0].productId;
                        tvingAccount.ticketName = tvingTickets[0].ticketName;
                        tvingAccount.tvingTickets = tvingTickets;
                    }
                    if (userToken) {
                        setCookie(CACHE_KEY.USER_TOKEN, userToken, { path: '/', maxAge: COOKIE_MAX_AGE, domain: '.tving.com' });
                        setCookie(CACHE_KEY.TVING_TOKEN, userToken, { path: '/', maxAge: COOKIE_MAX_AGE, domain: '.tving.com' });
                        localStorage.setItem(CACHE_KEY.USER_TOKEN, userToken);
                        localStorage.setItem(CACHE_KEY.TVING_TOKEN, userToken);
                        ReactGA.set({ dimension1: userToken });
                        ReactGA.set({ userId: userToken });
                        // 앰플리튜드 그룹세팅
                        seGroupAmplitude(decodeURI(userToken));
                        Sentry.configureScope(function (scope) {
                            scope.setExtra('userNo', tvingAccount.userNo);
                            scope.setExtra('userToken', tvingAccount.userToken);
                            scope.setExtra('userId', tvingAccount.userId);
                            scope.setUser({
                                id: tvingAccount.userNo,
                            });
                        });
                    }
                    if (authToken) {
                        setCookie(CACHE_KEY.AUTH_TOKEN, authToken, { path: '/', maxAge: COOKIE_MAX_AGE, domain: '.tving.com' });
                        setCookie(CACHE_KEY.AUTH_TOKEN_NEW, authToken, { path: '/', maxAge: COOKIE_MAX_AGE, domain: '.tving.com' });
                        localStorage.setItem(CACHE_KEY.AUTH_TOKEN, authToken);
                    }
                    if (accessToken) {
                        setCookie(CACHE_KEY.ACCESS_TOKEN, accessToken, { path: '/', domain: '.tving.com' });
                        localStorage.setItem(CACHE_KEY.ACCESS_TOKEN, accessToken);
                    }
                    if (refreshToken) {
                        setCookie(CACHE_KEY.REFRESH_TOKEN, refreshToken, { path: '/', maxAge: COOKIE_MAX_AGE, domain: '.tving.com' });
                        localStorage.setItem(CACHE_KEY.REFRESH_TOKEN, refreshToken);
                    }
                    if (regionCode) {
                        setCookie(CACHE_KEY.REGION_CODE, regionCode, { path: '/', maxAge: COOKIE_MAX_AGE, domain: '.tving.com' });
                        localStorage.setItem(CACHE_KEY.REGION_CODE, regionCode);
                    }
                    if (tvingUser.lastPasswordUpdateDate) {
                        setCookie(CACHE_KEY.LAST_PASSWORD_UPDATE_DATE, tvingUser.lastPasswordUpdateDate, {
                            path: '/',
                            maxAge: COOKIE_MAX_AGE,
                            domain: '.tving.com',
                        });
                        localStorage.setItem(CACHE_KEY.LAST_PASSWORD_UPDATE_DATE, tvingUser.lastPasswordUpdateDate);
                    }
                    // 최근 로그인한 로그인 타입 저장
                    if (tvingUser.userType) {
                        localStorage.setItem(CACHE_KEY.LAST_LOGIN_TYPE, tvingUser.userType);
                    }
                    if (!profileNo) return [3 /*break*/, 5];
                    _c.label = 2;
                case 2:
                    _c.trys.push([2, 4, , 5]);
                    _b = proxyProfile;
                    return [4 /*yield*/, fetchProfile({ profileNo: profileNo, userToken: userToken })];
                case 3:
                    tvingProfile_1 = _b.apply(void 0, [_c.sent()]);
                    tvingAccount.profileAdultCertifiedDate = tvingProfile_1.adultCertificationDate;
                    tvingAccount.profileToken = tvingProfile_1.profileToken;
                    tvingAccount.profileNo = tvingProfile_1.profileNo;
                    tvingAccount.profileName = tvingProfile_1.profileName;
                    tvingAccount.profileImageUrl = tvingProfile_1.profileImageUrl;
                    tvingAccount.adultCertificationDate = tvingProfile_1.adultCertificationDate;
                    tvingAccount.isMainProfile = tvingProfile_1.isMainProfile;
                    tvingAccount.hasPassword = tvingProfile_1.hasPassword;
                    // 앰플리튜드 로그이 프로필 선택 처리
                    setUserIdAmplitude(decodeURI(tvingAccount.profileToken));
                    setCookie(CACHE_KEY.PROFILE_NO, profileNo, {
                        path: '/',
                        maxAge: COOKIE_MAX_AGE,
                        domain: '.tving.com',
                    });
                    setProfile(tvingProfile_1);
                    setCookie(CACHE_KEY.TVING_TOKEN, tvingProfile_1.profileToken, {
                        path: '/',
                        maxAge: COOKIE_MAX_AGE,
                        domain: '.tving.com',
                    });
                    localStorage.setItem(CACHE_KEY.PROFILE_NO, profileNo);
                    localStorage.setItem(CACHE_KEY.TVING_TOKEN, tvingProfile_1.profileToken);
                    ReactGA.set({ dimension1: tvingProfile_1.profileToken });
                    ReactGA.set({ userId: tvingProfile_1.profileToken });
                    Sentry.configureScope(function (scope) {
                        scope.setExtra('profileNo', tvingProfile_1.profileNo);
                        scope.setExtra('profileToken', tvingProfile_1.profileToken);
                        scope.setExtra('profileName', tvingProfile_1.profileName);
                    });
                    PageNavigator.setDefaultUrl('/main');
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _c.sent();
                    throw new Error('프로필 정보를 가져오는데 실패했습니다.');
                case 5:
                    deviceType = getDeviceType();
                    // 안드로이드 티비의 경우 네이티브 앱에 로그인 정보 전달 필요
                    if (deviceType === DEVICE_TYPE.ANDROIDTV) {
                        try {
                            androidTvDeviceManager = DeviceManagerInstance;
                            androidTvDeviceManager.login((tvingAccount === null || tvingAccount === void 0 ? void 0 : tvingAccount.profileToken) || userToken, tvingAccount.userId, tvingAccount.userNo, profileNo || tvingAccount.userNo, userToken, authToken, accessToken, refreshToken);
                            androidTvDeviceManager.subscribeInfo(tvingAccount.ticketTier <= TICKET_TIER.BASIC && tvingAccount.ticketType === TICKET_TYPE.TVING ? 'F' : 'T');
                        }
                        catch (e) {
                            TvingLogModule.warn('안드로이드 티비의 경우 네이티브 앱에 로그인 정보 전달 필요하나 전달이 안됨');
                        }
                    }
                    setAccount(tvingAccount);
                    return [2 /*return*/, tvingAccount];
            }
        });
    }); }, [doLogout, lastPasswordUpdateDate, setAccount, setCookie, setProfile, showPopup]);
    var autoLoginRetryRef = useStateRef(0);
    var doAutoLogin = useCallback(function (userToken, lastPasswordUpdateDate, authToken, profileNo) { return __awaiter(void 0, void 0, void 0, function () {
        var tvingUser, _a, error_1, errorCode, refreshToken;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 6]);
                    _a = proxyAutoLogin;
                    return [4 /*yield*/, fetchAutoLogin({
                            userToken: userToken,
                            lastPasswordUpdateDate: lastPasswordUpdateDate,
                            deviceId: (deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.uuid) || uuid,
                            deviceName: deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.deviceModel,
                            deviceModel: deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.deviceModel,
                        })];
                case 1:
                    tvingUser = _a.apply(void 0, [_d.sent()]);
                    if (!tvingUser) {
                        TvingLogModule.warn("[Custom Error] AutoLogin result is not defined", {
                            userToken: userToken,
                            profileNo: profileNo,
                        });
                        doLogout();
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, updateAccount(tvingUser, profileNo)];
                case 2:
                    error_1 = _d.sent();
                    errorCode = (error_1 && ((_c = (_b = error_1.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.code)) || '';
                    if (!(errorCode === '4000' && autoLoginRetryRef.current !== 1)) return [3 /*break*/, 4];
                    // 재발급 시도 1회로 제한
                    autoLoginRetryRef.current = 1;
                    refreshToken = localStorage.getItem(CACHE_KEY.REFRESH_TOKEN);
                    if (!refreshToken) {
                        PageNavigator.replace('/logout');
                        return [2 /*return*/, null];
                    }
                    return [4 /*yield*/, createAccessTokenApi(refreshToken).then(function () {
                            var profileNo = localStorage.getItem(CACHE_KEY.PROFILE_NO) || cookies[CACHE_KEY.PROFILE_NO] || undefined;
                            doAutoLogin(userToken, lastPasswordUpdateDate, authToken, profileNo);
                        })];
                case 3:
                    _d.sent();
                    return [3 /*break*/, 5];
                case 4:
                    TvingLogModule.warn("[Custom Error] AutoLogin failed", {
                        userToken: userToken,
                        profileNo: profileNo,
                    });
                    doLogout();
                    autoLoginRetryRef.current = 0;
                    _d.label = 5;
                case 5: return [2 /*return*/, null];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [autoLoginRetryRef, cookies, deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.deviceModel, deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.uuid, doLogout, updateAccount, uuid]);
    var doAppLogin = useCallback(function (userId, password, loginType) { return __awaiter(void 0, void 0, void 0, function () {
        var tvingUser, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    _a = proxyAppLogin;
                    return [4 /*yield*/, fetchAppLogin({
                            userId: userId,
                            password: password,
                            loginType: loginType,
                            deviceId: (deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.uuid) || uuid,
                            deviceName: deviceInfo.deviceModel,
                            deviceModel: deviceInfo.deviceModel,
                        })];
                case 1:
                    tvingUser = _a.apply(void 0, [_c.sent()]);
                    if (tvingUser.code !== '0000') {
                        TvingLogModule.warn("[Custom Error] AppLogin failed", {
                            message: tvingUser.message,
                        });
                        return [2 /*return*/, tvingUser];
                    }
                    return [2 /*return*/, updateAccount(tvingUser)];
                case 2:
                    _b = _c.sent();
                    TvingLogModule.warn("[Custom Error] AppLogin failed", {
                        userId: userId,
                        loginType: loginType,
                    });
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [deviceInfo.deviceModel, deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.uuid, updateAccount, uuid]);
    var doQrLogin = useCallback(function (otpNum) { return __awaiter(void 0, void 0, void 0, function () {
        var tvingUser, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    _a = proxyOtpResultUser;
                    return [4 /*yield*/, fetchOtpResultUser({
                            uuid: (deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.uuid) || uuid,
                            deviceName: deviceInfo.deviceModel,
                            deviceModel: deviceInfo.deviceModel,
                            otpNum: otpNum,
                            pocType: 
                            // eslint-disable-next-line no-nested-ternary
                            getDeviceType() === DEVICE_TYPE.WEBOS
                                ? "APP_W_TVING_".concat(deviceInfo.appVersion)
                                : getDeviceType() === DEVICE_TYPE.TIZEN
                                    ? "APP_Z_TVING_".concat(deviceInfo.appVersion)
                                    : "APP_X_TVING_".concat(deviceInfo.appVersion),
                        })];
                case 1:
                    tvingUser = _a.apply(void 0, [_c.sent()]);
                    if (tvingUser.code !== '0000') {
                        TvingLogModule.warn("[Custom Error] QrLogin failed", {
                            message: tvingUser.message,
                        });
                        return [2 /*return*/, tvingUser];
                    }
                    return [2 /*return*/, updateAccount(tvingUser)];
                case 2:
                    _b = _c.sent();
                    TvingLogModule.warn("[Custom Error] QrLogin failed", {
                        otpNum: otpNum,
                    });
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [deviceInfo.appVersion, deviceInfo.deviceModel, deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.uuid, updateAccount, uuid]);
    var updateUserInfo = useCallback(function (userToken, authToken, accessToken, refreshToken, profileNo) { return __awaiter(void 0, void 0, void 0, function () {
        var tvingUser, _a, regionCode, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    setCookie(CACHE_KEY.TVING_TOKEN, userToken, { path: '/', maxAge: COOKIE_MAX_AGE, domain: '.tving.com' });
                    setCookie(CACHE_KEY.ACCESS_TOKEN, accessToken, { path: '/', domain: '.tving.com' });
                    setCookie(CACHE_KEY.REFRESH_TOKEN, refreshToken, { path: '/', maxAge: COOKIE_MAX_AGE, domain: '.tving.com' });
                    _a = proxyUserInfo;
                    return [4 /*yield*/, fetchUserInfo({ apiUserToken: userToken, uuid: (deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.uuid) || uuid })];
                case 1:
                    tvingUser = _a.apply(void 0, [_c.sent()]);
                    regionCode = localStorage.getItem(CACHE_KEY.REGION_CODE) || '';
                    if (!tvingUser) {
                        TvingLogModule.warn("[Custom Error] userInfo result is not defined", {
                            userToken: userToken,
                            profileNo: profileNo,
                        });
                        doLogout();
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, updateAccount(__assign(__assign({}, tvingUser), { userToken: userToken, authToken: authToken, accessToken: accessToken, refreshToken: refreshToken, regionCode: regionCode }), profileNo)];
                case 2:
                    _b = _c.sent();
                    TvingLogModule.warn("[Custom Error] userInfo failed", {
                        userToken: userToken,
                        profileNo: profileNo,
                    });
                    doLogout();
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.uuid, doLogout, setCookie, updateAccount, uuid]);
    return {
        // updateAccount,
        doAutoLogin: doAutoLogin,
        doAppLogin: doAppLogin,
        doQrLogin: doQrLogin,
        updateUserInfo: updateUserInfo,
        doLogout: doLogout,
        removeCache: removeCache,
    };
};
export default useAccount;
